/**
 * Route for `custom-currency-per-invoice`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CustomCurrencyPerInvoicePage } from "../features/custom-currency-per-invoice/CustomCurrencyPerInvoicePage";

export const customCurrencyPerInvoiceRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/custom-currency-per-invoice",
	component: CustomCurrencyPerInvoicePage,
});

export default customCurrencyPerInvoiceRoute;
